export enum EmployeeForms {
  UpdateEmployeeUserRoles = 'UpdateEmployeeUserRoles',
  DeleteEmployee = 'DeleteEmployee',
  InviteEmployee = 'InviteEmployee',
  EnrollEmployee = 'EnrollEmployee',
}
